import { FilterBase } from './filter-base.js';

/**
 * Boolean filter component.
 * Provides a Yes/No dropdown for boolean filtering.
 * @class
 * @extends {FilterBase}
 */
class FilterBoolean extends FilterBase {
    /**
     * Initialize the boolean filter component.
     * @constructor
     */
    constructor() {
        super();
        /** @type {HTMLSelectElement|null} The select dropdown element */
        this.selectElement = null;
    }

    /**
     * Renders the boolean filter component.
     * Creates a select element with Yes/No options.
     */
    render() {
        super.render();
        // Always show a Yes/No dropdown
        this.selectElement = document.createElement('select');
        this.selectElement.id = `filter-input-${this.filterData.name}`;
        this.selectElement.name = this.filterData.name;

        const yesOption = document.createElement('option');
        yesOption.value = '1';
        yesOption.textContent = 'Yes';
        this.selectElement.appendChild(yesOption);

        const noOption = document.createElement('option');
        noOption.value = '0';
        noOption.textContent = 'No';
        this.selectElement.appendChild(noOption);
        // Default selection to Yes
        this.selectElement.value = '1';

        this.appendChild(this.selectElement);
        window.setTimeout(() => {
            this.selectElement.dispatchEvent(new Event('change', {bubbles: true}));
        }, 100); // Delay to ensure the event is captured

    }

    /**
     * Gets the current boolean value from the select dropdown.
     * @returns {string|null} The current selected value ('0' or '1') or null if no select exists
     */
    getValue() {
        return this.selectElement ? this.selectElement.value : null;
    }
}

customElements.define('filter-boolean', FilterBoolean);
